// https://formatjs.io/docs/react-intl
// https://medium.com/javascript-in-plain-english/internationalization-in-react-apps-using-react-intl-1d72a6f14053

import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { base, load } from "../utils/api"
import Common from "../utils/common"

const common = new Common()
const { source, fallback } = common.getSource("", true)

function getSource(res: string) {
  return `/${base}/intl${res}`
}

const useIntlMessages = () => {
  const [messages, setMessages] = useState();

  useEffect(() => {
    load(getSource(source), fallback.map(getSource)).then(res => setMessages(res))
  }, []);

  return messages;
};

const InjectMessages = (props: { children: JSX.Element }) => {
  const messages = useIntlMessages();

  return (
    <>
      {Boolean(messages) && (
        // locale参数有一些限制，能接受zh、en，不能接受zh_cn，后续有时间再解决，暂不影响功能 
        <IntlProvider locale="en" messages={messages}>
          {props.children}
        </IntlProvider>
      )}
    </>
  );
};

export const Intl = (App: any) => () => (
  <InjectMessages>
    <App />
  </InjectMessages>
);
